import { SITE_URL, person, links, sameAs } from "./site";

const personId = `${SITE_URL}/#person`;
const hayanId = `${SITE_URL}/#hayan-tech`;
const vanakkamId = `${SITE_URL}/#vanakkam-dsa`;
const websiteId = `${SITE_URL}/#website`;

export const personSchema = {
  "@type": "Person",
  "@id": personId,
  name: person.name,
  alternateName: ["Hareesh R", "Hareesh"],
  jobTitle: person.headline,
  description: person.description,
  image: person.image,
  url: SITE_URL,
  email: person.email,
  sameAs,
  address: {
    "@type": "PostalAddress",
    addressLocality: "Chennai",
    addressRegion: "Tamil Nadu",
    addressCountry: "IN",
  },
  worksFor: { "@id": hayanId },
  alumniOf: {
    "@type": "CollegeOrUniversity",
    name: "RMK Engineering College",
  },
  knowsAbout: person.knowsAbout,
  nationality: { "@type": "Country", name: "India" },
};

export const hayanSchema = {
  "@type": "Organization",
  "@id": hayanId,
  name: "Hayan Tech",
  founder: { "@id": personId },
  description:
    "Company founded by Hareesh Rajendran. Home of Vanakkam DSA, a Tamil cohort-based DSA and interview preparation platform.",
};

export const vanakkamSchema = {
  "@type": "EducationalOrganization",
  "@id": vanakkamId,
  name: "Vanakkam DSA",
  url: links.vanakkamDsa,
  logo: `${SITE_URL}/images/vanakkam-dsa-logo.png`,
  image: `${SITE_URL}/images/vanakkam-dsa-logo.png`,
  founder: { "@id": personId },
  description:
    "A Tamil cohort-based DSA and interview preparation platform founded by Hareesh Rajendran.",
};

export const websiteSchema = {
  "@type": "WebSite",
  "@id": websiteId,
  name: person.name,
  url: SITE_URL,
  description: person.description,
  inLanguage: "en",
  publisher: { "@id": personId },
};

export const webpageSchema = (page) => ({
  "@type": "WebPage",
  "@id": `${SITE_URL}${page.path}#webpage`,
  url: `${SITE_URL}${page.path}`,
  name: page.title,
  description: page.description,
  isPartOf: { "@id": websiteId },
  about: { "@id": personId },
  inLanguage: "en",
});

export const profilePageSchema = {
  "@type": "ProfilePage",
  "@id": `${SITE_URL}/#profile`,
  url: SITE_URL,
  name: person.name,
  mainEntity: { "@id": personId },
  isPartOf: { "@id": websiteId },
};

export const breadcrumbSchema = (crumbs) => ({
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((crumb, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: crumb.name,
    item: `${SITE_URL}${crumb.path}`,
  })),
});

export const courseSchema = {
  "@type": "Course",
  name: "Vanakkam DSA",
  description:
    "Tamil cohort-based DSA and interview preparation founded by Hareesh Rajendran, covering problem solving and product-company preparation.",
  url: links.vanakkamDsa,
  provider: { "@id": vanakkamId },
  inLanguage: "ta",
};

export const buildGraph = (nodes) => ({
  "@context": "https://schema.org",
  "@graph": [personSchema, hayanSchema, vanakkamSchema, websiteSchema, ...nodes],
});
